import { render, staticRenderFns } from "./ReceiveCall.vue?vue&type=template&id=1f7fbb89&scoped=true"
import script from "./ReceiveCall.vue?vue&type=script&lang=js"
export * from "./ReceiveCall.vue?vue&type=script&lang=js"
import style0 from "./ReceiveCall.vue?vue&type=style&index=0&id=1f7fbb89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7fbb89",
  null
  
)

export default component.exports